// Opções para o dropdown de parametrização
export const PARAMETRIZACAO_OPCOES = ['Integrações', 'Requisições', 'Personalização', 'Usuários'] as const;
export type ParametrizacaoOpcao = typeof PARAMETRIZACAO_OPCOES[number];

// Locais para busca de usuários
export const SEARCH_USER_LOCATIONS = ['Integração', 'Ativos', 'Inativos', 'Todos'] as const;
export type SearchUserLocation = typeof SEARCH_USER_LOCATIONS[number];

// Parâmetros para busca de usuários
export const SEARCH_USER_PARAMETERS = [
  'Nome',
  'CPF',
  'Whatsapp',
  'Email',
  'UserName',
  'Código da Loja Vinculada',
] as const;
export type SearchUserParameter = typeof SEARCH_USER_PARAMETERS[number];

// Parâmetros para ContactItemsSidePanelContent.tsx
export const TIPOS_REQUISICAO = ['COMPRA', 'PERDIDA'] as const;
export type TipoRequisicao = typeof TIPOS_REQUISICAO[number];

// Origens possíveis de uma requisição (usadas em regras-aprovacao-requisicao)
export const ORIGENS_REQUISICAO = ['PLANEJAMENTO', 'BALCAO'] as const;
export type OrigemRequisicao = typeof ORIGENS_REQUISICAO[number];

// Origem agregada em capas de conferência: além de PLANEJAMENTO/BALCAO, pode ser
// TODAS quando a ordem de compra agrupa itens de requisições de origens diferentes
// (backend: COUNT(DISTINCT r.origem) > 1). TODAS NÃO é valor de filtro nem de
// requisição/OC individual — só aparece na leitura de capas de conferência (ADR-007).
export const ORIGENS_CONFERENCIA = ['PLANEJAMENTO', 'BALCAO', 'TODAS'] as const;
export type OrigemConferencia = typeof ORIGENS_CONFERENCIA[number];

// Prioridades para itens de requisição
export const PRIORIDADES = ['NORMAL', 'URGENTE'] as const;
export type Prioridade = typeof PRIORIDADES[number];

// Locais para busca no Kanban de Gestão de Compras // src/pages/po/AdvancedSearchPurchasesKanbanModalContent.tsx
export const SEARCH_PURCHASES_LOCATIONS = [
  'Requisições Pendentes',
  'Cotações',
  'Ordens de Compra Abertas',
  'Ordens de Compra Finalizadas',
] as const;
export type SearchPurchasesLocation = typeof SEARCH_PURCHASES_LOCATIONS[number];

// Portal de suporte (Jira Service Desk). Fonte única do link — o rodapé do
// `ProtectedLayout` e o `AppErrorFallback` consomem daqui.
// NOTA: `Login.tsx` e `RedefinirSenha.tsx` ainda repetem a URL literal; migrar
// os dois é faxina de escopo separado (telas de autenticação, premissa #2).
export const SUPPORT_URL =
  'https://bluelt.atlassian.net/servicedesk/customer/portal/1/user/login?destination=portal%2F1';